/**
 *
 * Login
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import img from "images/brand/Mandu_white.svg"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { Helmet } from "react-helmet"
// import reducer from "./reducer"
// import saga from "./saga"
import PageLogo from "../../components/PageLogo"
import { TwoFactorAuthComponent } from "../../components/TwoFactorAuth"
import saga from "../Login/saga"
import reducer from "../Login/reducer"
import makeSelectLogin, {
  makeSelectError,
  makeSelectErrorMessage,
  makeSelectErrorExceed,
  makeSelectLoading,
} from "../Login/selectors"
import {
  loginWatcher,
  loginReset,
  loginCompanyWatcher,
  loginFailed,
  loginProofIntegrated,
  resendTwoFactorCodeWatcher,
} from "../Login/actions"
import { isEqual } from "lodash"
import { KEY_TEMP_AF, LOCAL_MODULES } from "../../utils/storage"
import { LanguageSelector } from "../../components/LanguageSelector"

/* eslint-disable react/prefer-stateless-function */
export class TwoFactorAuth extends React.Component {
  UNSAFE_componentWillMount = () => {
    const user = JSON.parse(sessionStorage.getItem(KEY_TEMP_AF))?.email

    if (!user) {
      const {
        push,
        location: { state },
      } = this.props.history
      push("/login")
    }
  }

  componentDidUpdate = (prevProps) => {
    if (!isEqual(this.props.login.isLoggedIn, prevProps.login.isLoggedIn)) {
      const {
        push,
        location: { state },
      } = this.props.history
      if (validRole({ role: [1, 2, 3, 4] })) {
        if (
          this.props.login.twoFactorAuthResponse != undefined &&
          this.props.login.twoFactorAuthResponse
        ) {
          push("/organization")
        } else {
          push("/two_factor_authentication")
        }
        /*
        if (typeof window.Intercom !== 'undefined'){
          window.fcWidget.open()
        }
        */
      } else {
        if (
          this.props.login.twoFactorAuthResponse != undefined &&
          this.props.login.twoFactorAuthResponse
        ) {
          const modules = JSON.parse(LOCAL_MODULES())

          let dashboardModule = modules.find((mod) => mod.slug === "dashboard")
          if (dashboardModule?.mode === "disable") push("/reports")
          else push("/") // default dashboard
        } else {
          push("/two_factor_authentication")
        }
      }
    }
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>MandüHr</title>
          <meta name="description" content="Description of OrganizationPage" />
        </Helmet>
        <LanguageSelector/>
        <PageLogo>
          <TwoFactorAuthComponent
            error={this.props.error}
            loginProof={this.props.onLoginProof}
            errorExceed={this.props.errorExceed}
            errorMessage={this.props.errorMessage}
            reset={this.props.onReset}
            loading={this.props.loading}
            img={img}
            login={this.props.onLogin}
            resend={this.props.resend}
          />
        </PageLogo>
      </div>
    )
  }
}

TwoFactorAuth.propTypes = { onLogin: PropTypes.func.isRequired }

const mapStateToProps = createStructuredSelector({
  login: makeSelectLogin(),
  error: makeSelectError(),
  errorExceed: makeSelectErrorExceed(),
  errorMessage: makeSelectErrorMessage(),
  loading: makeSelectLoading(),
})

function mapDispatchToProps(dispatch) {
  return {
    onLogin: (params) => dispatch(loginWatcher(params)),
    onLoginProof: (params) => dispatch(loginProofIntegrated(params)),
    onReset: () => dispatch(loginReset()),
    loginCompany: (params) => dispatch(loginCompanyWatcher(params)),
    loginFailed: (params) => dispatch(loginFailed(params)),
    resend: (params) => dispatch(resendTwoFactorCodeWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "login", reducer })
const withSaga = injectSaga({ key: "login", saga })

export default compose(withReducer, withSaga, withConnect)(TwoFactorAuth)
